var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExmark = function SvgExmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m3.316.66-.292 8.312H.774L.484.659zM.402 11.532c0-.32.134-.59.403-.807.276-.223.646-.335 1.11-.335.463 0 .83.112 1.098.335.276.217.414.486.414.807 0 .316-.138.582-.414.8-.268.217-.635.326-1.099.326-.463 0-.833-.109-1.109-.326-.269-.218-.403-.484-.403-.8"
  })));
};
export default SvgExmark;